import { v4 as uuidv4 } from 'uuid';

import { reportUsageV2 } from '../../../api/usageV2';
import { GroupSearchSubmittedProps } from '../events/searchEvents.types';
import { getTimeFromSearchConversationStart } from '../getTimeFromSearchConversationStart';
import { loadProtobuf } from '../lazyExports';

const packageName = 'events';
const eventName = 'GroupSearchSubmittedV1';
const emptyId = 'ERROR - no-conversation-id';

type ReportGroupSearchSubmitted = (props: GroupSearchSubmittedProps) => void;
export const reportGroupSearchSubmitted: ReportGroupSearchSubmitted = async ({
  conversationId,
  logicalId,
  queryLength,
  wordCount,
  conversationStart,
}) => {
  const { events } = await loadProtobuf();

  const timeToActionMilliseconds = getTimeFromSearchConversationStart(conversationStart);

  const groupSearchSubmittedProps = {
    conversationId: conversationId ?? emptyId,
    logicalId: logicalId ?? uuidv4(),
    length: queryLength,
    wordCount,
    timeToActionMilliseconds,
  };

  const groupSearchViewSubmitted = events.GroupSearchSubmittedV1.encode(groupSearchSubmittedProps).finish();

  reportUsageV2({
    packageName,
    eventName,
    value: groupSearchViewSubmitted,
  });
};
